import { render, staticRenderFns } from "./headTitle.vue?vue&type=template&id=0ba383e6&scoped=true&"
import script from "./headTitle.vue?vue&type=script&lang=js&"
export * from "./headTitle.vue?vue&type=script&lang=js&"
import style0 from "./headTitle.vue?vue&type=style&index=0&id=0ba383e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba383e6",
  null
  
)

export default component.exports